/**
 * Cart drawer + AJAX add — Section Rendering pattern (Dawn-style):
 * κάθε cart mutation → re-fetch του section `cart-drawer` → swap HTML.
 * Συμπεριφορά parity με live (add → drawer ανοίγει με το προϊόν),
 * υλοποίηση καθαρή (όχι ο σπασμένος cart?view=test.json fetch — Q2 ruling).
 */
(function () {
  var dialog = document.querySelector('[data-cart-drawer]');
  if (!dialog) return;
  var sectionWrap = dialog.firstElementChild; // το shopify-section wrapper

  function openDrawer() {
    if (!dialog.open) dialog.showModal();
  }

  function updateCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  function refreshDrawer(open) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          sectionWrap.innerHTML = tmp.firstElementChild.innerHTML;
        }
        updateCount();
        if (open) openDrawer();
        /* TASK 3: το engraving-sync.js ακούει και συγχρονίζει τις fee-γραμμές */
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }

  // Intercept κάθε product form add
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || form.hasAttribute('data-no-ajax')) return;
    e.preventDefault();
    var btn = form.querySelector('[data-atc-button]');
    if (btn) btn.disabled = true;
    /* TASK 14A πιλότος: σε μονόπετρο η ΠΕΤΡΑ προστίθεται ΠΡΩΤΗ και fail-CLOSED —
       αντίθετα από το χάραγμα (fee 15€, fail-open με δίχτυ Trello), εδώ η γραμμή
       ΕΙΝΑΙ το διαμάντι: δαχτυλίδι χωρίς πέτρα σε τιμή σκελετού = λάθος πώληση.
       Αν η πέτρα αποτύχει (π.χ. μόλις πουλήθηκε — απόθεμα 1) → τίποτα δεν μπαίνει. */
    var stone = window.__monoPendingStone || null;
    var stoneStep = Promise.resolve();
    if (stone) {
      /* E2E-εύρημα πιλότου: σε ήδη-γεμάτο απόθεμα το /cart/add.js γυρίζει 200 και
         ΚΟΒΕΙ σιωπηλά την πέτρα (όχι 422) ενώ το δαχτυλίδι θα πήγαινε ×2 →
         pre-check: η ίδια πέτρα ΔΕΝ ξαναμπαίνει (κάθε πέτρα = μοναδική). */
      stoneStep = fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var dup = (c.items || []).some(function (it) {
            return it.variant_id === stone.id ||
              (it.properties && String(it.properties._stone_variant) === String(stone.id));
          });
          if (dup) throw new Error('Αυτό το διαμάντι είναι ήδη στο καλάθι σας — κάθε πέτρα είναι μοναδική. Επιλέξτε διαφορετική πέτρα για δεύτερο δαχτυλίδι.');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: stone.id, quantity: 1, properties: { 'Δαχτυλίδι': stone.ringSku } })
          });
        }).then(function (r) {
          if (!r.ok) throw new Error('Το επιλεγμένο διαμάντι δεν είναι πλέον διαθέσιμο — παρακαλούμε επιλέξτε άλλη πέτρα.');
        });
    }
    stoneStep
      .then(function () { return fetch('/cart/add.js', { method: 'POST', body: new FormData(form) }); })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) {
          if (stone) {
            /* rollback πέτρας — το monopetro-sync είναι το δίχτυ, αυτό η αμεσότητα */
            var updates = {};
            updates[stone.id] = 0;
            fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
          }
          throw new Error(j.description || 'error');
        });
        return r.json();
      })
      .then(function () {
        /* TASK 3 fast-ATC: αν το PDP έχει χρέωση χαράγματος, προστίθεται ΤΩΡΑ
           (όχι post-refresh sync = χωρίς ορατή καθυστέρηση)· στο drawer-μονοπάτι
           fail-open (δίχτυ = engraving-sync στο επόμενο render)· στο instant-
           checkout fail-CLOSED — μετά το redirect ΔΕΝ υπάρχει επόμενο render
           (ρίζα του incident Σ07-12: πληρωμή χωρίς το fee). */
        var fee = window.__engPendingFee | 0;
        if (fee > 0 && window.__engFeeVariantId) {
          return window.__engFeeVariantId(fee).then(function (vid) {
            if (!vid) throw new Error('fee unavailable');
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: vid, quantity: 1 })
            }).then(function (r) { if (!r.ok) throw new Error('fee add failed'); });
          }).catch(function (err) {
            if (window.__instantCheckout) {
              throw new Error('Η χρέωση χαράγματος δεν μπόρεσε να προστεθεί — δοκιμάστε ξανά.');
            }
            return null;
          });
        }
      })
      .then(function () {
        /* ΙΝCIDENT-FIX Σ07-12: «Αγορά τώρα» = ίδιο pipeline + redirect αντί για drawer */
        if (window.__instantCheckout) {
          window.__instantCheckout = false;
          window.location.href = '/checkout';
          return;
        }
        // live parity: ATC μέσα στο quickview → το QV κλείνει, ο drawer ανοίγει
        var qv = document.querySelector('[data-quickview-dialog]');
        if (qv && qv.open) qv.close();
        return refreshDrawer(true);
      })
      .catch(function (err) {
        window.__instantCheckout = false;
        alert(err.message || 'Κάτι πήγε στραβά.');
      })
      .finally(function () {
        if (btn) btn.disabled = false;
        var bn = document.querySelector('[data-buy-now]');
        if (bn) bn.disabled = false;
      });
  });

  // Header cart icon → drawer
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) {
      e.preventDefault();
      refreshDrawer(true);
      return;
    }

    var closeBtn = e.target.closest('[data-cart-drawer-close]');
    if (closeBtn) { dialog.close(); return; }

    var addBtn = e.target.closest('[data-add-guarantee], [data-add-cross]');
    if (addBtn) {
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(addBtn.getAttribute('data-variant-id'), 10), quantity: 1 })
      }).then(function () { return refreshDrawer(false); });
      return;
    }

    var item = e.target.closest('.cart-drawer__item');
    if (item) {
      var line = parseInt(item.getAttribute('data-line'), 10);
      var input = item.querySelector('[data-qty-input]');
      var qty = parseInt(input && input.value, 10) || 1;
      if (e.target.closest('[data-qty-minus]')) changeLine(line, qty - 1, item);
      else if (e.target.closest('[data-qty-plus]')) changeLine(line, qty + 1, item);
      else if (e.target.closest('[data-remove-line]')) changeLine(line, 0, item);
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-qty-input]')) return;
    var item = e.target.closest('.cart-drawer__item');
    if (!item) return;
    var qty = parseInt(e.target.value, 10);
    if (isNaN(qty) || qty < 0) qty = 1;
    changeLine(parseInt(item.getAttribute('data-line'), 10), qty, item);
  });

  function changeLine(line, quantity, itemEl) {
    /* Σ07-13 (owner-εύρημα «η χρέωση αργεί να φύγει»): αν το προϊόν χρωστά χρέωση
       χαράγματος, προϊόν + χρέωση αλλάζουν σε ΕΝΑ /cart/update.js (ακαριαίο, ένας
       γύρος, πάντα αληθινό σύνολο) — το desired-JSON είναι server-υπολογισμένο.
       Οποιοδήποτε κενό/σφάλμα → παλιός δρόμος + sync-δίχτυ (fail-open). */
    var batched = tryFeeBatch(quantity, itemEl);
    if (batched) { batched.then(function () { return refreshDrawer(false); }); return; }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { return refreshDrawer(false); });
  }

  function tryFeeBatch(quantity, itemEl) {
    try {
      var key = itemEl && itemEl.getAttribute('data-key');
      if (!key || !window.__engFeeVariantId) return null;
      var el = document.querySelector('[data-eng-desired]');
      if (!el) return null;
      var fees = (JSON.parse(el.textContent).fees || []);
      var mine = fees.filter(function (o) { return o.k === key; });
      if (!mine.length) return null; /* χωρίς χρέωση → κανονικός δρόμος */
      var feeVal = mine[0].f; /* ίδιο ποσό ανά μονάδα του ίδιου item */
      return window.__engFeeVariantId(feeVal).then(function (vid) {
        if (!vid) throw new Error('no fee variant');
        var others = fees.filter(function (o) { return o.k !== key && o.f === feeVal; }).length;
        var updates = {};
        updates[key] = quantity;          /* line-item key του προϊόντος */
        updates[vid] = others + quantity; /* variant id της χρέωσης */
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { if (!r.ok) throw new Error('update failed'); });
      }).catch(function () {
        /* fail-open: πίσω στο απλό change — το sync θα συμμαζέψει τη χρέωση */
        var lineAttr = parseInt(itemEl.getAttribute('data-line'), 10);
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: lineAttr, quantity: quantity })
        });
      });
    } catch (e) { return null; }
  }

  // click στο backdrop κλείνει
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) dialog.close();
  });
})();
